import { Order, OrdersUpdateRequest } from './Order'

export type Testimony = Omit<Order, 'collections'> & { cases: Order['collections'] }

export type TestimonyResponse = { testimony: Testimony }

export type TestimonyUpdateRequest = OrdersUpdateRequest

export const mapTestimonyToOrder = (testimony: Testimony): Order => {
    const { cases, ...rest } = testimony

    return { ...rest, collections: cases }
}
